module.exports = __webpack_public_path__ + "media/images/favicon-8d88446ecc03d86950d9743f1bd58cce.ico";